import ApiService from "@/api/ApiService";

/**
 * Список возможных ответственных за сделку в Bitrix для селекта
 * «Ответственный (Bitrix)» в формах создания B2C-курса.
 *
 * Отдельный эндпоинт, а не users-стор: общий GET /api/users.json для роли
 * manager отдаёт только сотрудников закреплённых за ним компаний, поэтому
 * админы и другие менеджеры (у которых заполнен bitrix_id) в список не
 * попадали и селект у менеджеров был пустым.
 */
export default {
  data() {
    return {
      bitrixManagers: [],
    };
  },
  computed: {
    managerItems() {
      return this.bitrixManagers.map((u) => ({
        value: u.id,
        text:
          [u.first_name, u.last_name].filter(Boolean).join(" ").trim() ||
          u.email ||
          `User #${u.id}`,
      }));
    },
  },
  beforeMount() {
    this.loadBitrixManagers();
  },
  methods: {
    async loadBitrixManagers() {
      const response = await ApiService.get("api/users/bitrix-managers");
      if (response.success === false) {
        this.bitrixManagers = [];
        return;
      }
      this.bitrixManagers = response.data || [];
    },
  },
};
